import React from 'react';

export const IconArrowBottom = ({
  size = 10,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <svg
      className={className}
      width={0.9 * size}
      height={1.1 * size}
      viewBox="0 0 9 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 11L0 6.5L1.062 5.438L3.75 8.125V0H5.25V8.125L7.938 5.438L9 6.5L4.5 11Z"
        fill="currentColor"
      />
    </svg>
  );
};
